import { OPEN_HAMBURGER_MENU, OPEN_SEARCHBAR, MEMBER_UPDATED, IS_OPEN_LOGIN_FORM } from "./actions";

const storyReducerState = {
  moreStories: [],
  latestTenStories: [],
  latestSectionStories: [],
  makeSecondaryApiCalls: false,
  delay: 500,
  isStickyBannerVisible: false
};

const storyReducer = (state = storyReducerState, action) => {
  switch (action.type) {
    case "MORE_STORIES":
      return {
        ...state,
        moreStories: action.payload
      };
    case "SET_LATEST_TEN_STORIES":
      return {
        ...state,
        latestTenStories: action.payload
      };
    case "SET_LATEST_SECTION_STORIES":
      return {
        ...state,
        latestSectionStories: action.payload
      };
    case "SET_MAKE_SECONDARY_API_CALLS_TRIGGERED":
      return {
        ...state,
        makeSecondaryApiCalls: action.makeSecondaryApiCalls,
        delay: action.delay
      };
    case "SET_IS_STICKY_BANNER_VISIBLE":
      return {
        ...state,
        isStickyBannerVisible: action.payload
      };
    default:
      return state;
  }
};

function hamburgerMenuReducer(state = false, action) {
  switch (action.type) {
    case OPEN_HAMBURGER_MENU:
      return action.isHamburgerMenuOpen;
    default:
      return state;
  }
}

function searchBarReducer(state = false, action) {
  switch (action.type) {
    case OPEN_SEARCHBAR:
      return action.isSearchBarOpen;
    default:
      return state;
  }
}

function memberReducer(state = null, action) {
  switch (action.type) {
    case MEMBER_UPDATED:
      return action.member;

    default:
      return state;
  }
}

function loginReducer(state = false, action) {
  switch (action.type) {
    case IS_OPEN_LOGIN_FORM:
      return action.payload;
    default:
      return state;
  }
}

export const REDUCERS = {
  isHamburgerMenuOpen: hamburgerMenuReducer,
  isSearchBarOpen: searchBarReducer,
  member: memberReducer,
  isLoginOpen: loginReducer,
  storyReducer: storyReducer
};
